<ng-container *ngIf="_willAdd !== true">
    <button
        class="cmps-button--no-bg cmps-cdk-color-blue-100 cmps-cdk-font-size-14p cmps-cdk-w-100pct cmps-cdk-justify-content-flex-start"
        cmpsButton
        (click)="_onWillAddClick()"
    >
        <cmps-icon
            class="cmps-cdk-fill-blue-100"
            svgIcon="checkbox-marked-circle-plus-outline"
        ></cmps-icon>
        <span cmpsButtonLabel>{{ _i18n._11234_ADD_A_TASK | translate }}</span>
    </button>
</ng-container>

<ng-container *ngIf="_willAdd === true">
    <div class="cmps-cdk-d-flex cmps-cdk-p-0dot5">
        <cmps-task-list-task-marker
            class="cmps-cdk-flex-5 cmps-cdk-d-flex cmps-cdk-justify-content-center"
            [completed]="_item.completed"
            (click)="_onMarkerClick()"
        ></cmps-task-list-task-marker>
        <cmps-task-list-task-title
            class="cmps-cdk-flex-95 cmps-cdk-pr-0dot5"
            [editing]="true"
            [title]="_item.title"
            [msftTaskId]="_item.msftTaskId"
            [placeholder]="_i18n._11235_TASK_TITLE | translate"
            #titleRef
        ></cmps-task-list-task-title>
    </div>
    <div
        class="cmps-cdk-d-flex cmps-cdk-p-0dot5 cmps-cdk-bg-color-grey-200 cmps-cdk-border-radius-5px"
    >
        <div class="cmps-cdk-flex-80 cmps-cdk-d-flex cmps-cdk-pl-0dot25">
            <cmps-task-list-task-props
                class="cmps-cdk-d-flex"
                [overdue]="_item.overdue"
                [dueDateTime]="_item.dueDateTime"
                [important]="_item.important"
                (dueDateTimeChange)="_onDueDateTimeChange($event)"
                (importanceClick)="_onImportanceClick()"
            ></cmps-task-list-task-props>
            <cmps-task-list-task-actions
                class="cmps-cdk-d-flex"
                (deleteClick)="_onDeleteClick()"
            ></cmps-task-list-task-actions>
        </div>
        <div
            class="cmps-cdk-flex-20 cmps-cdk-d-flex cmps-cdk-justify-content-flex-end"
        >
            <button
                class="cmps-outline-button--sm cmps-cdk-border-color-blue-100 cmps-cdk-color-blue-100 not:disabled:hover:cmps-cdk-bg-color-blue-100 not:disabled:focus:cmps-cdk-bg-color-blue-100 not:disabled:hover:cmps-cdk-color-white not:disabled:focus:cmps-cdk-color-white not:disabled:hover:cmps-cdk-pseudo-child not:disabled:focus:cmps-cdk-pseudo-child"
                cmpsOutlineButton
                [disabled]="!(titleRef.nextTitle?.length > 0)"
                (click)="_onAddClick()"
            >
                <span cmpsOutlineButtonLabel>{{
                    _i18n._11236_ADD | translate
                }}</span>
            </button>
        </div>
    </div>
</ng-container>
